// Global constants for the application

export const CURRENCY = "XOF";

/**
 * The currency's label on its own, for the places that need it next to an
 * input rather than next to an amount — a price field's suffix. Amounts
 * themselves go through `formatMoney` (src/utils/money-utils.ts), which gets
 * this same spelling from CLDR; MED-1543 reported the two drifting apart
 * ("Fcfa" vs "F CFA" vs "FCFA" on three screens).
 */
export const CURRENCY_SUFFIX = "F CFA";
export // Other global constants can be added here
const APP_NAME = "Medicine360 Admin";
export const VERSION = "1.0.0";
